module.exports = __webpack_public_path__ + "static/media/sc37.42.d481df7f.mp4";